/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementHistoryItemViewModel } from "../types/CourseRegistrationManagementHistoryItemViewModel.ts";
import { eEnrollmentStatusSchema } from "./eEnrollmentStatusSchema.ts";

export const courseRegistrationManagementHistoryItemViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID do registro de histórico de status."),
  ),
  oldStatus: z.optional(
    z
      .lazy(() => eEnrollmentStatusSchema)
      .describe(
        "1 = PaymentSelection | 2 = PaymentPending | 3 = ApprovalPending | 4 = Approved | 5 = Activating | 6 = Active | 7 = Transferred | 8 = TransferredInRegistration | 9 = Canceled | 10 = CanceledInRegistration | 11 = Rejected | 12 = FinishedWithPendencies | 13 = Finished | 14 = FinishedWithMonograph | 15 = FinishedWithCertificate | 16 = Blocked | ",
      ),
  ),
  newStatus: z.optional(
    z
      .lazy(() => eEnrollmentStatusSchema)
      .describe(
        "1 = PaymentSelection | 2 = PaymentPending | 3 = ApprovalPending | 4 = Approved | 5 = Activating | 6 = Active | 7 = Transferred | 8 = TransferredInRegistration | 9 = Canceled | 10 = CanceledInRegistration | 11 = Rejected | 12 = FinishedWithPendencies | 13 = Finished | 14 = FinishedWithMonograph | 15 = FinishedWithCertificate | 16 = Blocked | ",
      ),
  ),
  reasonName: z
    .string()
    .describe("Nome do motivo associado à alteração de status. Opcional.")
    .nullish(),
  subReasonName: z
    .string()
    .describe("Nome do submotivo associado à alteração de status. Opcional.")
    .nullish(),
  observation: z
    .string()
    .describe("Observação registrada junto à alteração de status. Opcional.")
    .nullish(),
  creationDate: z
    .string()
    .datetime()
    .describe("Data em que a alteração de status foi registrada. Opcional.")
    .nullish(),
  creationUser: z
    .string()
    .describe("Usuário que registrou a alteração de status. Opcional.")
    .nullish(),
}) as unknown as ToZod<CourseRegistrationManagementHistoryItemViewModel>;
